import { Card } from '@apigrowfinance/pbolt-card';
import { useParams } from 'react-router-dom';

import IllustratedMessageLoadingError from '@components/LoadingErrorMessage/LoadingErrorMessage';
import { useAccount } from '@contexts/AccountProvider';
import useGetCustomers from '@hooks/queries/useGetCustomers';
import Users from '@pages/accountDetail/tabs/users/Users';

const UsersContainer = () => {
    const { accountId } = useParams();

    const {
        isLoading: isLoadingAccounts,
        error: { accountIsError },
    } = useAccount();

    const {
        data,
        isError,
        isLoading: isLoadingCustomerDetail,
        refetch,
    } = useGetCustomers(+accountId);

    const isErrorAny = accountIsError || isError;
    if (isErrorAny) {
        return (
            <Card isTopRadiusBorder={false}>
                <IllustratedMessageLoadingError />
            </Card>
        );
    }

    return (
        <Users
            isLoading={isLoadingAccounts || isLoadingCustomerDetail}
            customerDetails={data?.items}
            onRefetch={refetch}
        />
    );
};

export default UsersContainer;
